<div class="wrapper-inner user_screen">
  <div class="container-fluid">
    <div class="row">

      <div class="col-md-12 userTables">
        <h2 *ngIf="!isModal">change password</h2>
              <div class="row justify-content-center">
                <div class="col-md-12">
                  <form class="admin_form" [formGroup]="formData" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                      <label class="text-capitalize font-weight-bold mb-0" for="">old password</label>
                      <input type="password" class="form-control" id="" formControlName="old_password"
                        [ngClass]="{ 'is-invalid': submitted && f.old_password.errors }">
                      <div *ngIf="submitted && f.old_password.errors" class="invalid-feedback">
                        <div *ngIf="f.old_password.errors.required">The Old Password field is required</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="text-capitalize font-weight-bold mb-0" for="">new password</label>
                      <input type="password" class="form-control" formControlName="new_password"
                        [ngClass]="{ 'is-invalid': submitted && f.new_password.errors }">
                      <div *ngIf="submitted && f.new_password.errors" class="invalid-feedback">
                        <div *ngIf="f.new_password.errors.required">The New Password field is required</div>
                        <div *ngIf="f.new_password.errors.minlength">The New Password field must be at least 6 characters
                        </div>
                        <div *ngIf="!f.new_password.errors.minlength && f.new_password.errors.pattern">The New Password must
                          contain at least: 1 uppercase letter, 1 lowercase letter, 1 number</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="text-capitalize font-weight-bold mb-0" for="">confirm password</label>
                      <input type="password" class="form-control" formControlName="new_password_re"
                        [ngClass]="{ 'is-invalid': submitted && f.new_password_re.errors }">
                      <div *ngIf="submitted && f.new_password_re.errors" class="invalid-feedback">
                        <div *ngIf="f.new_password_re.errors.required">The Confirm Password field is required</div>
                        <div *ngIf="f.new_password_re.errors.mustMatch">The Confirm Password confirmation does not match
                        </div>
                      </div>
                    </div>
                    <div class="form-group mt-2">
                      <button type="submit" class="btn btnSubmit">change password</button>
                    </div>
                  </form>
                </div>
              </div>
            
      </div>
    </div>
  </div>
</div>